import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58aea178"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-remark-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xingxing" }, "*"),
  /*#__PURE__*/_createElementVNode("span", null, "备注")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-uploader-label" }, "附件上传", -1))
const _hoisted_3 = { class: "upload-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传文件", -1))

import { ref, watch, withDefaults } from "vue";
import { message } from "ant-design-vue";
import type { UploadProps, UploadChangeParam } from "ant-design-vue";
import axios from "axios";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";

import { approve } from "@/api/openapply";

export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: 0 },
    show: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { id: number, show: boolean }



const rejectResume = ref<string>("");
const visible = ref<boolean>(false);
const disableClose = ref<boolean>(true);
const uploadTypeValue = ref<string>("");
const fileList = ref([]);
const PageFiles = ref<
  {
    FileName: string;
    FileUrl: string;
  }[]
>([]);
const loading = ref<boolean>(false);
const headers = {
  Authorization: sessionStorage.getItem("token"),
};

watch(
  () => props.show,
  (val) => (visible.value = val)
);

//添加驳回理由
const setRejectResume = async () => {
  if (!rejectResume.value) {
    message.error("请填写备注");
    return;
  }
  const { Success } = await approve({
    Description: rejectResume.value,
    WorkflowId: props.id,
    Status: 2, //1:通过 2: 驳回
    PageFiles: PageFiles.value,
  });
  if (Success) {
    message.success("已驳回");
    handleCancelResume();
  } else {
    message.error("驳回失败");
    handleCancelResume();
  }
};
const handleCancelResume = () => {
  rejectResume.value = "";
  // visible.value = false;
  $emit("close");
};
// 获取文件类型
const getFileType = (imgObj: string) => {

  // 1: 图片  2： paf  3： word  4: txt  5 zip 6 excel 7 ppt 8 other
  let val = 1;
  const SrcArr = imgObj.split(".");
  if (SrcArr.includes("pdf") || SrcArr.includes("PDF")) {
    val = 2;
  } else if (SrcArr.includes("doc") || SrcArr.includes("docx")) {
    val = 3;
  } else if (SrcArr.includes("txt")) {
    val = 4;
  } else if (SrcArr.includes("zip") || SrcArr.includes("rar")) {
    val = 5;
  } else if (
    SrcArr.includes("excel") ||
    SrcArr.includes("xlsx") ||
    SrcArr.includes("xls")
  ) {
    val = 6;
  } else if (SrcArr.includes("ppt")) {
    val = 7;
  } else if (
    SrcArr.includes("jpg") ||
    SrcArr.includes("png") ||
    SrcArr.includes("jpeg") ||
    SrcArr.includes("gif") ||
    SrcArr.includes("JPG") ||
    SrcArr.includes("PNG") ||
    SrcArr.includes("JPEG") ||
    SrcArr.includes("GIF")
  ) {
    val = 1;
  } else {
    val = 8;
  }
  return val;
};

const beforeUpload = (file: UploadProps["fileList"][number]) => {
  //todo: excel表格兼容
  const type = getFileType(file.name);
  const isPermit =
    type == 1 || type == 2 || type == 3 || type == 5 || type == 6 || type == 8;
  // ".pdf,image/png, image/jpeg, image/gif, image/jpg, .zip,.doc,.docx,.xls";
  if (!isPermit) {
    message.error("支持上传图片、pdf、Excel、word、.xls、压缩包!");
  }
  const isLt20M = file.size / 1024 / 1024 < 45;
  if (!isLt20M) {
    message.error("上传不得超过45M");
  }
  return isLt20M && isPermit;
};
const handleChange = (info: UploadChangeParam) => {
  if (info.file.status === "uploading") {
    loading.value = true;
    return;
  }
  if (info.file.status === "done") {
    loading.value = false;
    const { Data = [], Success, Message } = info.file.response;
    if (Success) {
      if (Data && Data.length > 0) {
        uploadTypeValue.value = Data[0].Url;
        PageFiles.value[0].FileName = Data[0].FileName || [];
        PageFiles.value[0].FileUrl = Data[0].Url || [];
      }
      loading.value = false;
      disableClose.value = false;
      message.success("上传成功");
    } else {
      disableClose.value = true;
      message.error(Message || "上传失败");
    }
  }
  if (info.file.status === "error") {
    loading.value = false;
    disableClose.value = true;
    message.error("上传失败");
  }
};
const resetField = () => {
  loading.value = false;
  fileList.value = [];
  uploadTypeValue.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "modal-dialog",
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "驳回意见",
    onOk: setRejectResume,
    onCancel: handleCancelResume
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_textarea, {
        value: rejectResume.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rejectResume).value = $event)),
        placeholder: "请填写",
        maxlength: 1000,
        "auto-size": { minRows: 5, maxRows: 5 }
      }, null, 8, ["value"]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (uploadTypeValue.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(uploadTypeValue.value ? 'hover-uploader' : '')
            }, [
              (!disableClose.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "close",
                    onClick: resetField
                  }))
                : _createCommentVNode("", true),
              (getFileType(uploadTypeValue.value) === 1)
                ? (_openBlock(), _createBlock(_component_a_image, {
                    key: 1,
                    style: {"width":"104px","height":"104px","z-index":"10","padding":"0"},
                    src: uploadTypeValue.value
                  }, null, 8, ["src"]))
                : (getFileType(uploadTypeValue.value) === 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: require('../assets/imgs/Common/pdf_1.png'),
                      alt: ""
                    }, null, 8, _hoisted_4))
                  : (getFileType(uploadTypeValue.value) === 3)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 3,
                        src: require('../assets/imgs/Common/word_1.png'),
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : (getFileType(uploadTypeValue.value) === 5)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 4,
                          src: require('../assets/imgs/Common/zip_1.png'),
                          alt: ""
                        }, null, 8, _hoisted_6))
                      : (getFileType(uploadTypeValue.value) === 6)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 5,
                            src: require('../assets/imgs/Common/excel_1.png'),
                            alt: ""
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createBlock(_component_a_upload, {
              key: 1,
              name: "value",
              "list-type": "picture-card",
              class: "avatar-uploader",
              action: `${_unref(axios).defaults.baseURL}api/file/uploadFile`,
              headers: headers,
              "before-upload": beforeUpload,
              onChange: handleChange,
              "show-upload-list": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 })),
                  _hoisted_8
                ])
              ]),
              _: 1
            }, 8, ["action"]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})